<template>
  <div class="container">

    <router-link :to="'/newUser/' + usertype" class="btn btn-sm btn-link">
      <i class="icon icon-plus"></i>Create new {{usertype}}
    </router-link>

    <div v-if="usertype === 'admin'" class="divider"></div>

    <ul v-if="usertype === 'client'" class="tab">
      <li class="tab-item" @click.prevent="tab = 0" :class="{active: tab === 0}">
        <a href="#">Clients</a>
      </li>
      <li class="tab-item" @click.prevent="tab = 1" :class="{active: tab === 1}">
        <a href="">Prospects</a>
      </li>
      <li class="tab-item" @click.prevent="tab = 2" :class="{active: tab === 2}">
        <a href="">Archived</a>
      </li>
    </ul>

    <div class="container">
      <div class="columns" v-for="(user, key) in userlist">
        <div class="column col-1 col-md-2">
          <router-link :to="'/users/' + user._id" v-bind:user="user">
            <avatar :user="user" :key="user._id"></avatar>
          </router-link>
        </div>
        <div class="column col-11 col-md-10">
          <div class="columns">
            <div class="column col-4 col-md-12">
              <router-link :to="'/users/' + user._id">
                {{user.profile.corporate ? user.profile.business : user.profile.firstname + ' ' + user.profile.lastname}}
              </router-link>
            </div>
            <div class="column col-4 col-md-12"><a :href="`mailto:${user.email}`">{{user.email}}</a></div>
            <div class="column col-4 col-md-12"><a :href="`tel:${user.profile.phone}`">{{user.profile.phone}}</a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import avatar from '@/components/users/avatar'

export default {
  name: 'users',
  components: { avatar: avatar },
  props: ['usertype'], // 'client' or 'admin'
  data () {
    return {
      users: [],
      tab: 0
    }
  },
  created () {
    this.setup()
  },
  watch: {
    '$route': function (to, from) {
      this.setup()
    }
  },
  computed: {
    userlist () {
      if (this.usertype === 'admin') {
        return this.users  // Return all admins
      }
      if (this.tab === 0) {
        return this.users.filter(u => { return !u.archived && u.level === 5 })
      }
      if (this.tab === 1) {
        return this.users.filter(u => { return !u.archived && u.level === 6 })
      }
      if (this.tab === 2) {
        return this.users.filter(u => { return u.archived && u.level >= 5 })
      }
    }
  },
  methods: {
    setup () {
      if (this.usertype === 'client') {
        this.$root.$data.pageTitle = 'Clients'
      } else {
        this.$root.$data.pageTitle = 'Team'
      }
      this.getUsers()
    },
    getUsers: function () {
      let path = null
      if (this.usertype === 'client') {
        path = '/api/users/clientbriefs'
      } else {
        path = '/api/users/adminbriefs'
      }
      axios.get(path).then(res => {
        if (res.data) {
          this.users = res.data.sort((a, b) => {
            let aName = a.profile.corporate ? a.profile.business : a.profile.firstname
            let bName = b.profile.corporate ? b.profile.business : b.profile.firstname
            return aName.localeCompare(bName)
          })
        }
      }).catch(e => { console.log(e) })
    },
    delUser: function (user) {
      axios.post('/api/delete/users/' + user._id)
      .then(res => {
        if (res.status === 200) {
          this.getUsers()
        }
      })
      .catch(e => { console.log(e) })
    }
  }
}
</script>
<style scoped>
.columns {
  margin-bottom: 4px;
}
a.btn.btn-sm.btn-link {
  background: #D04881;
  color: #fff!important;
}
a.btn.btn-sm.btn-link i {
  margin: 0 0.5em 0 0;
}
a.btn.btn-sm.btn-link:hover {
  background-color: #b9336b
}
a, a.active, a:active, a:focus, a:hover {
  color:#136efb!important;
}
</style>



// WEBPACK FOOTER //
// users.vue?cb8a5cf4